export default "__VITE_ASSET__Uf4_Mq_h6hz3une2c30STA__"